document.addEventListener("DOMContentLoaded", () => {
  const $MapItem = $(".map-item-header");
  const $ListItem = $(".list-item-header");
  const $TagBtn = $(".tag-more-btn");
  const $Tags = $(".tag-item");

  $MapItem.click(function () {
    $(this).siblings(".child-link-box").slideToggle();
    $(this).toggleClass("active");
  });

  $ListItem.click(function () {
    $(this).siblings(".map-list-layout").slideToggle();
    $(this).toggleClass("active");
  });

  $TagBtn.click(function () {
    $(this).addClass("hide");
    $Tags.addClass("active");
  });
});
